import React, { useContext } from 'react';

import LiteralDisplay from './LiteralDisplay';
import AttachmentDisplay from './resource/AttachmentDisplay';
import StatementDisplay from './resource/StatementDisplay';
import Predicates from 'constants/predicates';
import ImageDisplay from './resource/ImageDisplay';
import SearchLink, { isSearchLink } from './resource/SearchLink';
import ResourceDisplay from './ResourceDisplay';

import Types, { isLiteral } from 'constants/types';
import FieldErrorBoundary from 'field/common/FieldErrorBoundary';
import FieldContext from 'field/FieldContext';

const Field = (props) => {
  const FC = useContext(FieldContext);

  let { field, shaded, defaultImage } = props;
  if (!field) {
    return null;
  }  
  let mode = props.mode || 'list';

  const Field = () => {
    const component = FC.getDisplayField(props);
    if (component != null) {
      return component;
    }

    switch (field.type) {
    case Types.ARCHIVE.IMAGE:
      return <ImageDisplay field={field} />;
    
    case Types.ARCHIVE.DOCUMENT:
      if(field.predicate == Predicates.SPECTRUM.CE.SIGNABLE_STATEMENT){
		return <StatementDisplay field={field} />;
	  }else{
      	return <AttachmentDisplay field={field} defaultImage={defaultImage} />;
      }
    }

    if (isSearchLink(field)) {
      return <SearchLink field={field} />;
    }
    if (isLiteral(field.type) || field?.props.enum || field?.props.term) {
      return <LiteralDisplay field={field} mode={mode} />;
    }
    return <ResourceDisplay field={field} mode={mode} shaded={shaded} />;
  };

  // Predicate attribute wrapper for debugging DOM
  return (
    <div
      predicate={field.predicate}
      className="field-container" 
      aria-label="Field">
      <Field />
    </div>
  );
};

const FieldDisplay = props => (
  <FieldErrorBoundary field={props.field} >
    <Field {...props} />
  </FieldErrorBoundary>
);

export default FieldDisplay;

export const FieldDisplayRow = props => <FieldDisplay mode='row' {...props} />;

export const FieldDisplayNoHeader = props => <FieldDisplay mode='no-header' {...props} />;
